// extracted by mini-css-extract-plugin
module.exports = {"warning-container":"warning-container-FIITF","warning-statement":"warning-statement-I7pdD","warning-button":"warning-button-zlx_V","warning-label":"warning-label-XJnBc"};